import { useBreadcrumb } from "features/breadcrumbs";
import { Flex } from "@chakra-ui/layout";
import { useFindAreaComum } from "features/area-comum/hooks";
import { useCurrentTenant } from "features/auth/tenant.store";
import { useLoading } from "infra/helpers/alerta";
import PageHeader from "components/Page/PageHeader";
import RUG from "react-upload-gallery";
import "react-upload-gallery/dist/style.css";
import { useEffect, useState } from "react";
import { getToken } from "infra/http";
import config from "infra/config";
import { useRouteMatch } from "react-router";
import PrimaryButton from "components/Button/PrimaryButton";
import history from "infra/helpers/history";
import useDeleteImagensAreaComum from "features/area-comum/hooks/useDeleteImagensAreaComum";
import Container from "components/Container";

function AreaComumImagensPage() {
  const route = useRouteMatch<{ id: string }>();

  const { tenant } = useCurrentTenant();

  const { isLoading, data } = useFindAreaComum(tenant.id, route.params.id);

  const { mutate: handleDelete } = useDeleteImagensAreaComum(
    tenant.id,
    route.params.id
  );

  useLoading(isLoading);

  useBreadcrumb([
    { name: "Cadastros", url: "/cadastros" },
    { name: "Áreas comuns", url: "/cadastros/areas-comum" },
    { name: "Imagens" },
  ]);

  const onWarning = (type: any, rules: any) => {
    switch (type) {
      case "accept":
        console.log(`Only ${rules.accept.join(", ")}`);
        break;

      case "limit":
        console.log("limit <= ", rules.limit);
        break;

      case "size":
        console.log("max size <= ", rules.size);
        break;

      case "minWidth":
      case "minHeight":
        console.log("Dimensions > ", `${rules.width.min}x${rules.height.min}`);
        break;

      case "maxWidth":
      case "maxHeight":
        console.log("Dimensions < ", `${rules.width.max}x${rules.height.max}`);
        break;
    }
  };

  const [accessToken, setAccessToken] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      const result = await getToken();

      setAccessToken(result);
    })();
  }, []);

  return (
    <Container>
      <Flex flexDir="row">
        <Flex>
          <PageHeader
            title={
              <span>
                Imagem da Área comum <strong>{data?.nome ?? "---"}</strong>
              </span>
            }
          />
        </Flex>
        <Flex flex={1} justifyContent="flex-end">
          <PrimaryButton
            onClick={() => {
              history.push(`/cadastros/areas-comum`);
            }}
          >
            Voltar
          </PrimaryButton>
        </Flex>
      </Flex>

      {!isLoading ? (
        <RUG
          onDeleted={(i: any) => {
            const item = data?.imagens.find((item) => item.url === i.source);

            if (item) {
              handleDelete(item.id as any);
            }
          }}
          initialState={
            data?.imagens.map((item) => ({
              source: item.url,
            })) ?? []
          }
          action={`${config.urlApi}/v1/tenants/${tenant.id}/area-comum/${route.params.id}/upload-imagem`}
          rules={{
            limit: 15,
            size: 200,
            // width: {
            //   min: 1280,
            //   max: 1920,
            // },
            height: {
              min: 180,
              max: 180,
            },
          }}
          accept={["jpg", "jpeg", "png", "gif"]}
          onWarning={onWarning}
          headers={{
            authorization: `Bearer ${accessToken}`,
          }}
        />
      ) : null}
    </Container>
  );
}

export default AreaComumImagensPage;
